import React, { Component } from "react";
import { connect } from "react-redux";
import * as appActions from "../../../_actions/appActions";
import Wrapper from "../../../_hoc/Wrapper";
import Section from "../../UI/Section";
import SimpleList from "../../UI/SimpleList";
import Modal from "react-responsive-modal";
import ProfileInfoWithImage from "./ProfileInfoWithImage";
import FollowList from "./FollowList";
import ProfileInformation from "./ProfileInformation";
import AccountCreatedModal from "../../UI/AccountCreatedModal";
import getDisplayName from "../../../_selectors/userSelectors/getDisplayName";
import getMyGender from "../../../_selectors/userSelectors/getMyGender";
import MyInformation from "../../UI/MyInformation";
const simpleListItem = [
  {
    text: () => (
      <Wrapper>
        <i class="fa fa-address-book" /> My Information
      </Wrapper>
    ),
    onClick: component => {
      component.toggleModal();
    }
  },
  {
    text: () => (
      <Wrapper>
        <i class="fa fa-comments" /> Messages
      </Wrapper>
    ),
    onClick: component => {
      component.openMessages();
    }
  },
  {
    text: (
      <Wrapper>
        <i class="fa fa-photo" /> Gallery
      </Wrapper>
    ),
    to: "/gallery"
  },
  {
    text: (
      <Wrapper>
        <i class="fa fa-bullhorn" /> Notifications
      </Wrapper>
    ),
    to: "/notifications"
  },
  {
    text: (
      <Wrapper>
        <i class="fa fa-eye-slash" /> Privacy
      </Wrapper>
    ),
    to: "/profile/privacy"
  },
  {
    text: (
      <Wrapper>
        <i class="fa fa-cogs" /> Settings
      </Wrapper>
    ),
    to: "/settings"
  }
];
class ProfileHome extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.location.state) {
      if (nextProps.location.state.openModal && !prevState.modelOpened) {
        return { openModal: true, modelOpened: true };
      }
      return null;
    }
    return null;
  }
  state = { openModal: false, modelOpened: false };
  componentDidMount() {
    const { updateHeader, updateBreadcrumb } = this.props;
    updateHeader({
      title: "Profile",
      description: "You in a nutshell"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Profile", link: "/profile" }
    ]);
  }
  openMessages = () => {
    const { openMessages } = this.props;
    openMessages();
  };
  toggleModal = () => {
    const { name } = this.props;

    this.setState(prevState => ({
      openModal: !prevState.openModal
    }));
  };
  render() {
    const { name, isFemale } = this.props;
    const { openModal } = this.state;
    return (
      <Wrapper>
        <Section>
          <div className="row row-wider">
            <div className="col-md-3">
              <ProfileInfoWithImage />
              <SimpleList items={simpleListItem} component={this} hover />
              <FollowList />
            </div>
            <div className="col-md-9">
              <ProfileInformation />
            </div>
          </div>
        </Section>
        <Modal
          open={openModal}
          onClose={this.toggleModal}
          center
          showCloseIcon={false}
          classNames={{ overlay: "amst-overlay", modal: "amst-modal" }}
        >
          <MyInformation
            name={name === "Welcome, User" ? "" : name}
            onClose={this.toggleModal}
          />
        </Modal>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  name: getDisplayName(state),
  isFemale: getMyGender(state)
});

const mapDispatchToProps = dispatch => ({
  openMessages: () => dispatch(appActions.toggleRightbar(true))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileHome);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/index.js